import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, TextField } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";

type GenreByBroadcaster = {
  broadcasterId: number;
  value: string;
};
type GenreMetadataInfos = {
  name: string;
  genresByBroadcaster: GenreByBroadcaster[];
};

interface MetadataInputGenresProps extends MetadataInputProps {
  multiple: boolean;
}

const MetadataInputGenres = forwardRef<any, MetadataInputGenresProps>((props, ref) => {
  const { onChange, data, value, multiple = false } = props;

  const localValue = useMemo(() => {
    if (!value) return [];
    if (!Array.isArray(value)) return value.value;
    return value;
  }, [value]);

  return (
    <Autocomplete
      id={data.tagName!}
      // options management
      options={data.values ? data.values!.map((v) => v.valueObject).map((v) => v?.value as GenreMetadataInfos) : []}
      // value management
      value={(localValue as GenreMetadataInfos[]) || []}
      onChange={(e, value) => onChange(value, data.id)}
      getOptionLabel={(option) => option.name}
      multiple={multiple}
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
    />
  );
});

export default MetadataInputGenres;
